// extracted by mini-css-extract-plugin
export default {"cardsContainer":"styles_cardsContainer__41MAR","slide-in-bottom":"styles_slide-in-bottom__42nqF"};